"use strict";

exports.__esModule = true;
exports["default"] = SocialFacebook;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function SocialFacebook(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M511 26.5v459c0 14.1-11.4 25.5-25.5 25.5H358V332.6h63.2l13.3-76.5H358v-51c0-14.2 7.6-25.5 17-25.5h59.5V103H375c-51.5 0-93.5 45.8-93.5 102v51H222v76.5h59.5V511h-255C12.4 511 1 499.6 1 485.5v-459C1 12.4 12.4 1 26.5 1h459C499.6 1 511 12.4 511 26.5z",
    fill: "#939496"
  }));
}